.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-0_5, 4px);
  padding: 2px 8px;
  background: var(--tuna-surface-elevated, var(--tuna-palette-background-paper));
  border: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
  border-radius: var(--tuna-shape-radius-sm);
  font-size: var(--tuna-typography-fontSize-xs);
  line-height: 1.4;
  color: var(--tuna-content-secondary);
  cursor: pointer;
  transition:
    background-color 120ms ease,
    border-color 120ms ease,
    color 120ms ease;
}

.chip:hover,
.chip:focus-visible {
  background-color: var(--tuna-palette-action-hover, rgba(0, 0, 0, 0.04));
  border-color: var(--tuna-content-secondary);
}

.chip:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.chip[data-state='called'] {
  color: var(--tuna-content-primary);
}

.chip[data-state='errored'] {
  color: var(--tuna-feedback-error);
  border-color: var(--tuna-feedback-error);
}

.icon {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}

/* Pulse the icon while the call is streaming so the chip feels live. */
.chip[data-state='streaming'] .icon {
  animation: streamPulse 1.4s ease-in-out infinite;
}

.verb {
  white-space: nowrap;
}

.toolName {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-content-secondary);
}

.chip[data-state='called'] .toolName,
.chip[data-state='errored'] .toolName {
  color: inherit;
}

.disclosure {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 4px 0 8px;
  padding: 8px;
  border: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
  border-radius: var(--tuna-shape-radius-sm);
  background: var(--tuna-surface-input, var(--tuna-palette-grey-50));
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-content-secondary);
}

.disclosureLabel {
  font-weight: 600;
  color: var(--tuna-content-secondary);
}

.disclosureBody {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: var(--tuna-typography-fontSize-xs);
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
}

.showFull {
  align-self: flex-start;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-palette-primary-main);
  text-decoration: underline;
}

.showFull:hover,
.showFull:focus-visible {
  text-decoration: none;
}

@keyframes streamPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
}

@media (prefers-reduced-motion: reduce) {
  .chip[data-state='streaming'] .icon {
    animation: none;
  }
}
